import { chatMessages } from './reducers';
export default chatMessages;
